import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

type Tone = 'neutral' | 'accent' | 'nebula' | 'success' | 'warning' | 'danger';

interface Props extends HTMLAttributes<HTMLSpanElement> {
  readonly tone?: Tone;
}

const styles: Record<Tone, string> = {
  neutral: 'bg-bg-hover text-fg-muted border border-border',
  accent: 'bg-accent/10 text-accent border border-accent/30',
  nebula: 'bg-nebula/10 text-nebula border border-nebula/30',
  success: 'bg-success/10 text-success border border-success/30',
  warning: 'bg-warning/10 text-warning border border-warning/30',
  danger: 'bg-danger/10 text-danger border border-danger/30',
};

export function Badge({ tone = 'neutral', className, ...rest }: Readonly<Props>) {
  return <span className={cn('orb-badge', styles[tone], className)} {...rest} />;
}
